<template>
  <div class="p-6">
    <h1 class="text-2xl font-bold mb-4">Importazione Prodotti</h1>

    <!-- Form per caricare il file -->
    <form @submit.prevent="uploadFile" enctype="multipart/form-data">
      <div class="mb-4">
        <label class="block mb-2 font-semibold">Seleziona un file Excel o CSV:</label>
        <input type="file" name="file" @change="handleFileUpload" class="border p-2 w-full" />
      </div>

      <button type="submit" class="bg-green-500 text-white px-4 py-2 rounded">
        🚀 Avvia Importazione
      </button>
    </form>

    <!-- Mostra errori -->
    <div v-if="importErrors.length > 0" class="mt-4 bg-red-200 p-4 rounded">
      <h3 class="font-semibold text-red-700">Errori durante l'importazione:</h3>
      <ul>
        <li v-for="(error, index) in importErrors" :key="index" class="text-red-600">{{ error }}</li>
      </ul>
    </div>

    <!-- Progress Bar -->
    <div v-if="importStatus === 'in_progress'" class="mt-4">
      <h3 class="font-semibold">Progresso Importazione</h3>
      <div class="w-full bg-gray-300 rounded h-6 mt-2">
        <div class="bg-blue-500 h-6 rounded" :style="{ width: progress + '%' }"></div>
      </div>
      <p class="mt-2">Prodotti Importati: {{ importedCount }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      progress: 0,
      importedCount: 0,
      importStatus: null,
      importErrors: [],
      interval: null,
    };
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async uploadFile() {
    if (!this.file) {
        alert("Seleziona un file!");
        return;
    }

    let formData = new FormData();
    formData.append("file", this.file);

    let csrfTokenTag = document.querySelector('meta[name="csrf-token"]');
    let csrfToken = csrfTokenTag ? csrfTokenTag.getAttribute("content") : null;

    try {
        const response = await fetch("/productsImport", {
            method: "POST",
            body: formData,
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                ...(csrfToken ? { "X-CSRF-TOKEN": csrfToken } : {}),
            },
        });

        const data = await response.json();

        if (!response.ok) {
            console.error("Errore ricevuto:", data);
            if (data.validation_errors) {
                alert("❌ Errore di validazione:\n" + data.validation_errors.join("\n"));
            } else {
                alert("❌ Errore durante l'importazione:\n" + (data.error || "Errore sconosciuto"));
            }
            throw new Error(data.error || "Errore sconosciuto");
        }

        alert(data.message);
        this.progress = 0;
        this.importedCount = 0;
        this.importStatus = "in_progress";
        this.importErrors = [];

        this.interval = setInterval(this.checkProgress, 1000);
    } catch (error) {
        alert("Errore durante l'importazione: " + error.message);
    }
},


    async checkProgress() {
      const response = await fetch("/productsImport/progress");
      const data = await response.json();
      this.progress = data.progress;
      this.importedCount = data.imported_count;
      this.importStatus = data.status;
      this.importErrors = data.errors || [];

      if (this.importStatus === "failed") {
        clearInterval(this.interval);
        alert("❌ Importazione fallita:\n" + this.importErrors.join("\n"));
      } else if (this.importStatus === "completed") {
        clearInterval(this.interval);
        alert("✅ Importazione completata con successo!\nProdotti importati: " + this.importedCount);
      }
    },
  },
};
</script>